import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import ScrollToTop from './components/ScrollToTop' 
import Inicio from './pages/Inicio';
import DetalleProducto from './pages/DetalleProducto';
import Productos from './pages/Productos'
import QuienesSomos from './pages/QuienesSomos'
import ComoProducimos from './pages/ComoProducimos'
import Footer from './components/Footer'

// Componentes provisorios para que la app no se rompa al navegar.

function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <ScrollToTop />
      {/* Contenedor principal donde se cargan las páginas */}
      <div style={{ padding: '0' }}>
        <Routes>
          <Route path="/" element={<Inicio />} />
          <Route path="/productos" element={<Productos />} />
          <Route path="/productos/:id" element={<DetalleProducto />} />
          <Route path="/quienes-somos" element={<QuienesSomos />} />
          <Route path="/como-producimos" element={<ComoProducimos />} />
        </Routes>
      </div>

    <Footer />

    </BrowserRouter>
  );
}

export default App;